/**
 * Created by chenzheyu on 2017/6/12.
 */
import XKTabs from './src/tabs'

XKTabs.install = function (Vue) {
  Vue.component(XKTabs.name, XKTabs)
}

export default XKTabs



// WEBPACK FOOTER //
// ./src/components/module/tabs/index.js